export default __webpack_public_path__ + "static/new-xcad-logo-4cc2a2eca85e8fc2e29fe60ee4655198.svg";